/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import OperationTheatreEquipment from './operation-theatre-equipment';
import OperationTheatreEquipmentDetail from './operation-theatre-equipment-detail';
import OperationTheatreEquipmentUpdate from './operation-theatre-equipment-update';
import OperationTheatreEquipmentDeleteDialog from './operation-theatre-equipment-delete-dialog';

const OperationTheatreEquipmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<OperationTheatreEquipment />} />
    <Route path="new" element={<OperationTheatreEquipmentUpdate />} />
    <Route path=":id">
      <Route index element={<OperationTheatreEquipmentDetail />} />
      <Route path="edit" element={<OperationTheatreEquipmentUpdate />} />
      <Route path="delete" element={<OperationTheatreEquipmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default OperationTheatreEquipmentRoutes;
